import { render } from "./DayDetail.vue?vue&type=template&id=68e08e7f&scoped=true"
import script from "./DayDetail.vue?vue&type=script&lang=js"
export * from "./DayDetail.vue?vue&type=script&lang=js"

import "./DayDetail.vue?vue&type=style&index=0&id=68e08e7f&scoped=true&lang=css"

import exportComponent from "/Users/pushpan/Projects/WebApps/Python/Django/store_manage/punil/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68e08e7f"]])

export default __exports__